import {
    SET_PROFILE_NAMES
} from '../types/profileNamesTypes';

const initialState = {
    list: [],
    selected: null
};

const profileNamesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PROFILE_NAMES:
            return { ...state, list: action.payload };

        default:
            return state;
    }
}

export default profileNamesReducer